import $ from "jquery";

window.ongBlack = {
    options: {
        targetLinks: "",
        targetLinksInactive: "",
        targetLinksActive: "",
        targetContent: "",
        callbackAfterShow: function (i, oi) {

        }
    },
    initHover: function (target) {
        $(target).hover(
            function () {
                if (!$(this).hasClass("active")) { $(this).addClass("on"); }
            },
            function () {
                $(this).removeClass("on");
            }
        );
    },
    initClick: function (target) {
        var oldindex, index, obj;
        obj = this;
        $(target).click(function () {
            oldindex = $(obj.options.targetLinksActive).parent().index();
            index = $(this).parent().index();

            $(obj.options.targetLinksActive).removeClass("active");
            $(obj.options.targetLinks).eq(index).addClass("active");

            obj.showOngs(index, oldindex);
            return false;
        });
    },
    showOngs: function (i, oi) {
        if(i != oi) {
            $(this.options.targetContent).eq(i).fadeIn();
            $(this.options.targetContent).eq(oi).fadeOut();
        }
        
        if (typeof this.options.callbackAfterShow === "function") {
            this.options.callbackAfterShow(i, oi);
        }
    },
    checkHasClassHide: function () {
        $(this.options.targetContent).each(function () {
            if ($(this).hasClass("hide")) {
                $(this).removeClass('hide').css("display", "none");
            }
        });
    },
    init: function () {
        // Declaration
        var links, chapt, linkActive, linksInactive;

        // Encapsulation
        links = this.options.targetLinks;
        linkActive = this.options.targetLinksActive;
        linksInactive = this.options.targetLinksInactive;

        // Call Methods
        this.checkHasClassHide(); // prepare items
        this.initHover(links); // bind hover
        this.initClick(links); // bind click
    }
};
